<div class="component">
  <muni-gameday-panel
    [title]="'PORTFOLIO OVERVIEW'"
    [isActive]="true"
    [condensed]="true"
    data-automation-e2e-selector="portfolioOverviewCardHeader"
  >
    <muni-gameday-loading [visible]="loading | async" [renderContent]="true">
      <muni-gameday-no-data
        [show]="(assetsStatus$ | async)?.noData"
        [message]="'NO PORTFOLIO DATA AVAILABLE'"
        data-automation-e2e-selector="noPortfolioData"
      >
        <div class="content">
          <div class="totalValues">
            <div>
              <span
                [textContent]="
                  getFormattedAUM((municipal | async)?.reportedAssetsAmount)
                    | NullToDashes
                "
                data-automation-e2e-selector="valueMuniAUM"
              >
              </span>
              <span
                *ngIf="(municipal | async)?.reportedAssetsAmount !== null"
                [ngClass]="muniChangeColor | async"
              >
                <span
                  [textContent]="
                    (Math.abs((municipal | async)?.aggregateChangePercentage)
                      | number: '1.0-1') + '%'
                  "
                  data-automation-e2e-selector="priorChange"
                >
                </span>
                <i
                  class="fa fa-arrow-up"
                  *ngIf="(muniPercentSign | async) === 1"
                  data-icon
                  data-automation-e2e-selector="priorChangeArrow"
                ></i>
                <i
                  class="fa fa-arrow-down"
                  *ngIf="(muniPercentSign | async) === -1"
                  data-icon
                  data-automation-e2e-selector="priorChangeArrow"
                ></i>
              </span>
            </div>
            <div
              data-automation-e2e-selector="valueTotalAUM"
              [textContent]="
                getFormattedAUM(totalAssets | async) | NullToDashes
              "
            ></div>
          </div>
          <div class="totalLabels">
            <div data-automation-e2e-selector="labelMuniAUM">
              MUNI AUM (USD, mm)
            </div>
            <div data-automation-e2e-selector="labelTotalAUM">
              Total AUM (USD, mm)
            </div>
          </div>
          <div class="statisticSection">
            <muni-gameday-no-data
              [show]="(assetsStatus$ | async)?.noAssets"
              [message]="'NO PORTFOLIO HOLDINGS DATA'"
              data-automation-e2e-selector="noPortfolioHoldingsData"
            >
              <div class="chart">
                <muni-gameday-donut-chart
                  [data]="chartData | async"
                  [innerRadius]="20"
                  [outerRadius]="30"
                  data-automation-e2e-selector="doughnutChart"
                ></muni-gameday-donut-chart>
              </div>
              <div class="statistic">
                <div data-automation-e2e-selector="fixedIncomeHeader">
                  FIXED INCOME PORTFOLIO HOLDINGS
                </div>
                <div
                  class="statisticContent"
                  data-automation-e2e-selector="fixedIncomeContainer"
                >
                  <div
                    class="muni"
                    data-automation-e2e-selector="muniPortfolioHoldings"
                  >
                    <div>
                      <span
                        class="square"
                        [ngStyle]="{ background: muniColor }"
                        data-automation-e2e-selector="muniColor"
                      >
                      </span>
                      <span
                        [textContent]="muniType"
                        data-automation-e2e-selector="muniName"
                      >
                      </span>
                    </div>
                    <div
                      [textContent]="
                        (municipal | async)?.sharePercentageByAssetType
                          | iexNoRoundPercents
                          | NullToDashes
                      "
                      class="muniPercent"
                      [ngStyle]="{ color: muniColor }"
                      data-automation-e2e-selector="muniPercent"
                    ></div>
                    <div
                      [textContent]="
                        (municipal | async)?.securityCount
                          | number: '1.0-2'
                          | NullToDashes
                      "
                      class="muniHoldings"
                      data-automation-e2e-selector="numberOfHoldings"
                    ></div>
                    <span data-automation-e2e-selector="holdingsLabel">
                      HOLDINGS
                    </span>
                  </div>
                  <div
                    class="types"
                    data-automation-e2e-selector="otherPortfolioHoldings"
                  >
                    <div
                      *ngFor="let asset of assets | async"
                      data-automation-e2e-selector="securityTypeInfo"
                    >
                      <div
                        class="square square-category"
                        [ngStyle]="{
                          background: getElementColor(asset?.parentSecurityType)
                        }"
                        data-automation-e2e-selector="securityTypeColor"
                      ></div>
                      <span
                        [textContent]="asset?.parentSecurityType"
                        data-automation-e2e-selector="securityTypeName"
                      >
                      </span>
                      <span
                        [textContent]="
                          asset?.sharePercentageByAssetType
                            | iexNoRoundPercents
                            | NullToDashes
                        "
                        class="boldLetter"
                        data-automation-e2e-selector="securityTypePercent"
                      >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </muni-gameday-no-data>
          </div>
        </div>
      </muni-gameday-no-data>
    </muni-gameday-loading>
  </muni-gameday-panel>
</div>
